import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NavigationEnd, Router } from '@angular/router';
import { AuthServiceService } from 'app/Authentification/auth-service.service';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { ReleaseVersionService } from 'app/Shared/Services/release-version.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { InputOtp, InputOtpModule } from 'primeng/inputotp';
import { ToastModule } from 'primeng/toast';
import { first } from 'rxjs';
import { RememberDevice } from '../remember-device/remember-device';

@Component({
  selector: 'app-verify-otp',
  imports: [CommonModule, FormsModule, ConfirmDialogModule,
		MatCardModule, MatFormFieldModule, MatInputModule, ToastModule,
		InputOtpModule, InputOtp, ButtonModule,RememberDevice],
  templateUrl: './verify-otp.html',
  styleUrl: './verify-otp.scss',
})
export class VerifyOtp {
  timeLeft: number = 600; // 10 min active session time
  interval: any;
  isExpired: boolean = false;
  otpValue: any;
  error: any;
  constructor(
    public authenticationService: AuthServiceService,
    public urlsService: UrlsService,
    public constantService: ConstantService,
    public confirmationService: ConfirmationService,
    private releaseVersionService: ReleaseVersionService,
    private router: Router,
    private messageService: MessageService) {
      this.authenticationService.rememberDevice=false;
  }

  ngOnInit() {
    this.startTimer();
    this.authenticationService.rememberDevice=false;
  }

  verifyOtp() {
      this.error="";
      if (!this.authenticationService.loading) {
        let payload = {
          "username": this.constantService.user.email,
          "session": this.authenticationService.session,
          "code": this.otpValue,
          "uiVersion":this.releaseVersionService.getReleaseVersion()
        }
        this.authenticationService.loading = true;
  
        this.authenticationService.verifyOtp(payload)
          .pipe(first())
          .subscribe({
            next: (result: any) => {  
              if (result?.success === true) {
  
                if (result?.tokens) {
                  this.authenticationService.setToken(result);
                } else {
                  this.error = "Login succeeded but tokens missing.";
                }
  
              } else {
                this.error = (result?.error || 'Something Went Wrong');
              }
            },
  
            error: (err: HttpErrorResponse) => {
              this.authenticationService.loading = false;
              if (err.status === 400) {
                this.error = "Invalid OTP, Invalid session for the user, session is expired.";
              } else if (err.status === 401) {
                this.error = "Session expired. Please login again.";
              } else {
                this.error = err?.error?.message || "Something went wrong.";
              }
              this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: this.error });
              this.isExpired = false;
            }
          });
      }
    }

    
    startTimer() {
      this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.isExpired = true;
        clearInterval(this.interval);
      }
      }, 1000);
    }
  
    ngOnDestroy() {
      if (this.interval) {
      clearInterval(this.interval);
      }
    }
  
    formatTime() {
      const minutes = Math.floor(this.timeLeft / 60);
      const seconds = this.timeLeft % 60;
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    }
  
    resendOtp() {
      this.otpValue="";
      this.error="";
      this.authenticationService.loading = true;
      this.authenticationService.mfa_login(this.constantService.user)
      .pipe(first())
			.subscribe({
				next: (result: any) => {
					if (result?.mfaRequired) {
						if (result?.type === "EMAIL_OTP") {
							this.authenticationService.loading = false;
              this.isExpired = false;
              this.startTimer()
							this.authenticationService.session = result?.session;
							this.messageService.add({ severity: 'success', summary: 'Success Message', detail: "OTP (One-Time Password) email (" + this.constantService.user.email + ") being sent successfully " });
						}else{
              this.authenticationService.loading = false;
              this.router.navigate(['/login']);
            }
          }
        },error: (err: HttpErrorResponse) => {
					this.authenticationService.loading = false;
					const errorMsg: any = err?.error?.message || err?.error?.error || '';
					if (err.status === 400) {
						this.error = "Incorrect username or password"
						if (errorMsg.includes("Password attempts exceeded")) {
							this.error = "Password attempts exceeded.";
						}
						else if (errorMsg.includes("Attempt limit exceeded")) {
							this.error = "Attempt limit exceeded. Please try again later.";
						}
					} else if (err.status === 401) {
						this.error = "Session expired. Please login again.";
					} else {
						this.error = err?.error?.message || "Something went wrong.";
					}
					this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: this.error });
				}});

      this.timeLeft = 180;
    }
  

}
